if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.progressKey = this.getAttribute('data-progress-key') || (this.hasAttribute('data-show-alert') ? 'cart-page' : 'cart-drawer');
      this.handleCartUpdated = this.init.bind(this);
    }

    connectedCallback() {
      this._ensureMarkup();
      document.addEventListener('cart-updated', this.handleCartUpdated);
      this.init();
    }

    disconnectedCallback() {
      document.removeEventListener('cart-updated', this.handleCartUpdated);
    }

    init() {

      window.KROWN = window.KROWN || {};
      window.KROWN.shippingNoticeProgress = window.KROWN.shippingNoticeProgress || {};
      window.KROWN.shippingNoticeState = window.KROWN.shippingNoticeState || {};

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const rate = Shopify.currency.rate ? Number(Shopify.currency.rate) : 1;
      const thresholdCents = Math.round(freeShippingThreshold * rate);
      const activeColor = '#007bff';
      const successColor = '#28a745';
      let shippingMessage = '';
      let shippingSuccess = false;
      let progressPercentage = 0;

      if ( cartTotal < thresholdCents ) {
        const remaining = thresholdCents - cartTotal;
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(remaining, KROWN.settings.shop_money_format));
        progressPercentage = (cartTotal / thresholdCents) * 100;
      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
        progressPercentage = 100;
      }

      const storedProgress = window.KROWN.shippingNoticeProgress[this.progressKey];
      const storedState = window.KROWN.shippingNoticeState[this.progressKey];
      const startingProgress = storedProgress != null ? storedProgress : progressPercentage;
      const initialProgress = Math.min(Math.max(startingProgress, 0), 100);
      const nextColor = shippingSuccess ? successColor : activeColor;
      const initialColor = storedState && storedState.color ? storedState.color : nextColor;

      this._ensureMarkup();

      if ( this.messageNode ) {
        if ( this.hasAttribute('data-show-alert') ) {
          this.messageNode.className = `alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}`;
          this.messageNode.innerHTML = shippingMessage;
        } else {
          this.messageNode.innerHTML = shippingMessage;
        }
      }

      const activeBar = this.progressBar;
      if ( activeBar ) {
        activeBar.style.width = `${initialProgress}%`;
        activeBar.style.backgroundColor = initialColor;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            activeBar.style.width = `${progressPercentage}%`;
            activeBar.style.backgroundColor = nextColor;
          });
        });
      }

      window.KROWN.shippingNoticeProgress[this.progressKey] = progressPercentage;
      window.KROWN.shippingNoticeState[this.progressKey] = {
        color: nextColor,
        success: shippingSuccess
      };

    }

    _ensureMarkup() {

      const shouldShowAlert = this.hasAttribute('data-show-alert');

      if ( ! this.messageNode ) {
        this.messageNode = document.createElement('div');
      }

      if ( ! this.progressTrack ) {
        this.progressTrack = document.createElement('div');
        this.progressTrack.className = 'progress-slider';
        this.progressTrack.style.height = '8px';
        this.progressTrack.style.background = 'rgba(204, 204, 204, 1)';
        this.progressTrack.style.borderRadius = '20px';
        this.progressTrack.style.position = 'relative';
        this.progressTrack.style.overflow = 'hidden';
      }

      if ( ! this.progressBar ) {
        this.progressBar = document.createElement('div');
        this.progressBar.className = 'progress-slider__active';
        this.progressBar.style.borderRadius = '20px';
        this.progressBar.style.height = '100%';
        this.progressTrack.appendChild(this.progressBar);
      }

      this.replaceChildren();

      if ( shouldShowAlert ) {
        this.messageNode.className = 'alert alert--wide';
        this.appendChild(this.messageNode);
      } else {
        this.messageNode.className = '';
        this.appendChild(this.messageNode);
      }

      this.appendChild(this.progressTrack);

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
